export function cleanQueryParams(params) {
  return Object.fromEntries(
    Object.entries(params).filter(
      // eslint-disable-next-line no-unused-vars
      ([_, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "UNKNOWN"
    )
  );
}
